import { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { sortBy } from 'lodash';
import { inject, observer } from 'mobx-react';

//components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';

//elements
import LoadingSpinner from '../../elements/LoadingSpinner';

//configs
import { BASE_URL } from '../../library/config';

//assets
import defaultAvatar from '~/assets/img/faces/face-0.jpg';
import newlogo from '../../assets/img/new-logo.png';

var ps;

class SidebarMobile extends Component {
    constructor(props) {
        super(props);
        const { routes } = props;
        this.state = {
            ...this.getCollapseStates(routes),
            isUserOpen: false,
            isDocumentsOpen: false,
            isWindows: navigator.platform.indexOf('Win') > -1 ? true : false,
            width: window.innerWidth,
        };
    }

    hideMenu() {
        this.props.userStore.hideSidebar();
    }

    getCollapseStates = (routes) => {
        let initialState = {};
        routes.map((prop) => {
            if (prop.collapse) {
                initialState = {
                    [prop.collapseId]: this.getCollapseInitialState(prop.views),
                    ...this.getCollapseStates(prop.views),
                    ...initialState,
                };
            }
            return null;
        });
        return initialState;
    };

    getCollapseInitialState(routes) {
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
                return true;
            } else if (window.location.href.indexOf(routes[i].path) !== -1) {
                return true;
            }
        }
        return false;
    }

    createLinks = (_routes) => {
        const { commonStore, userStore, t } = this.props;
        const routes = sortBy(_routes, (r) => {
            return r.order || 1;
        });
        const client = commonStore.config?.client;
        return routes.map((prop, key) => {
            if (prop.redirect) {
                return null;
            }
            if (prop.allowed && !prop.allowed(userStore.currentUser, client)) return null;
            if (prop.hide) return null;
            const showBadge = !!(prop.name === 'Chat' && !!userStore.messageNotificationsCount);
            if (prop.collapse) {
                const isGroupAllowed = prop.views.reduce((result, menuItem) => {
                    if (!menuItem.allowed) {
                        return true;
                    }
                    if (menuItem.allowed && menuItem.allowed(userStore.currentUser, client)) {
                        return true;
                    }
                    return result;
                }, false);
                if (!isGroupAllowed) {
                    return null;
                }
                var st = {};
                st[prop['collapseId']] = !this.state[prop.collapseId];
                return (
                    <li className={this.getCollapseInitialState(prop.views) ? 'active' : ''} key={key}>
                        <a
                            className="nav-link mainNavLink"
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState(st);
                            }}
                        >
                            <span className="d-flex">
                                <img src={prop.icon} className="sidebarIcon" />
                                <div>
                                    {(prop.name)}
                                    <b className={this.state[prop.collapseId] ? 'caret rotate-180' : 'caret'} />
                                </div>
                            </span>
                        </a>
                        <Collapse in={this.state[prop.collapseId]}>
                            <ul className="nav">{this.createLinks(prop.views)}</ul>
                        </Collapse>
                    </li>
                );
            }
            if (prop.url) {
                let url = prop.url;
                if (url === 'RULES') {
                    if (!commonStore?.config?.client?.data?.basicRules)
                        return null;
                    const { data: clientData } = commonStore.config.client;
                    url = clientData.basicRules.rulesLink;
                }
                return (
                    <li className={this.activeRoute(prop.layout + prop.path)} key={key}>
                        <a target="_blank" href={url} className="nav-link" onClick={() => this.hideMenu()}>
                            {prop.icon ? (
                                <span className="d-flex">
                                    <img src={prop.icon} className="sidebarIcon" />
                                    <p>{t(prop.name)}</p>
                                </span>
                            ) : (
                                <span className="d-flex">
                                    <span className="sidebar-mini">{prop.mini}&nbsp;</span>
                                    <span className="sidebar-normal" title={t(prop.name)}>
                                        {t(prop.name)}
                                    </span>
                                </span>
                            )}
                        </a>
                    </li>
                );
            }
            return (
                <li className={this.activeRoute(prop.layout + prop.path)} key={key}>
                    <NavLink to={prop.layout + prop.path} className="nav-link" onClick={() => this.hideMenu()}>
                        {prop.icon ? (
                            <span className="d-flex">
                                <img src={prop.icon} className="sidebarIcon" />
                                <div className="d-flex">
                                    {t(prop.name)}
                                    {showBadge && (
                                        <div className="chat-badge">
                                            {userStore.messageNotificationsCount}
                                        </div>
                                    )}
                                </div>
                            </span>
                        ) : (
                            <span className="d-flex">
                                <span className="sidebar-mini">{prop.mini}&nbsp;</span>
                                <span className="sidebar-normal" title={t(prop.name)}>
                                    {t(prop.name)}
                                </span>
                            </span>
                        )}
                    </NavLink>
                </li>
            );
        });
    };

    activeRoute = (routeName) => {
        return this.props.router.location.pathname === routeName ? 'active' : '';
    };

    updateDimensions() {
        this.setState({ width: window.innerWidth });
    }

    componentDidUpdate() {
        if (navigator.platform.indexOf('Win') > -1) {
            setTimeout(() => {
                if (ps) ps.update();
            }, 350);
        }
    }
    componentDidMount() {
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions.bind(this));
    }


    handleDashboardLoad = (e) => {
        e.preventDefault();
        window.location.assign(BASE_URL);
    }

    render() {
        const { userStore, routes, t, handleLogOut, commonStore } = this.props
        if (!userStore.currentUser) return <LoadingSpinner />;

        if (userStore?.currentUser?.user?.is_now_locked)
            return null;

        const user_type = userStore?.currentUser?.user_type;
        const enable_2fa = commonStore?.config?.client?.enable_2fa

        return (
            <div className="new-sidebar-class sidebarMobile">
                <div className="logo">
                    <NavLink to="/" className="simple-text logomain" onClick={this.handleDashboardLoad}>
                        <img src={newlogo} alt="timeandcontrol" id="logoimg" />
                    </NavLink>
                </div>

                <div className="sidebar-wrapper" ref="sidebarWrapper">
                    <ul className="nav">
                        {this.createLinks(routes)}
                        {
                            (user_type === 'super-admin' || enable_2fa) &&
                            <li>
                                <NavLink to="/admin/security_settings" className="nav-link" onClick={() => this.hideMenu()}>
                                    <span className="d-flex align-items-center">
                                        <i className="fa fa-lock text-muted"></i>
                                        <div>
                                            {t('Security Settings')}
                                        </div>
                                    </span>
                                </NavLink>
                            </li>
                        }
                        <li>
                            <NavLink to="/" className="nav-link" onClick={handleLogOut}>
                                <span className="d-flex">
                                    <i
                                        className="fas fa-sign-out-alt fa-xl mt-1 text-danger"
                                        aria-hidden="true"
                                    ></i>
                                    <div className="d-flex">
                                        {t('Log out')}
                                    </div>
                                </span>
                            </NavLink>
                        </li>
                    </ul>
                    <br /><br /><br />
                </div>
            </div >
        );
    }
}

export default inject('userStore', 'commonStore')(applicationRouter(withLocalization(observer(SidebarMobile))));